<template>
  <main>
    <section class="prev-page-section" style="background-image:url(/static-assets/img/contact-img.jpg);">
      <div class="container">
        <div class="grey-title-block resp-number">Admin Panel</div>
      </div>
    </section>
    <section class="career-form-section">
      <div class="container">
        <div v-if="!isLogged()" class="career-form-wrapper admin-login-form">
          <form class="col-md-6 col-xl-4" @submit="LogIn" action="#">
            <span class="section-title">Antwerk</span>
            <h3>Admin LogIn</h3>
            <div class="row inputs-wrapper">
              <div>
                <input v-model="email" name="email" type="text" placeholder="Email">
              </div>
              <div>
                <input v-model="password" name="password" type="password" placeholder="Password">
              </div>
              <div  class="error-message">Не верный email или пароль!</div>
            </div>
            <div class="send-btns">
              <div class="submit-btn">
                <input type="submit" value="LogIn">
              </div>
            </div>
          </form>
        </div>
        <div v-else class="career-form-wrapper admin-login-form">
          <form id="hf-info-form" class="col-xl-12 col-md-8" @submit="submitInfo" action="#">
            <span class="section-title">Antwerk</span>
            <h3>Информация в шапке/подвале</h3>
            <span class="section-title">Текста ссылок</span>
            <div data-arr="links" class="inputs-wrapper">
              <div>
                <input v-model="links.home" name="links_home" type="text" placeholder="Главная">
              </div>
              <div>
                <input v-model="links.about" name="links_about" type="text" placeholder="О нас">
              </div>
              <div>
                <input v-model="links.services" name="links_services" type="text" placeholder="Сервисы">
              </div>
              <div>
                <input v-model="links.industry" name="links_industry" type="text" placeholder="Отраслевые решения">
              </div>
              <div>
                <input v-model="links.complex" name="links_complex" type="text" placeholder="Комплексные решения">
              </div>
              <div>
                <input v-model="links.vacancy" name="links_vacancy" type="text" placeholder="Карьера">
              </div>
              <div>
                <input v-model="links.contacts" name="links_contacts" type="text" placeholder="Контакты">
              </div>
              <div>
                <input v-model="links.news" name="links_news" type="text" placeholder="Новости">
              </div>
            </div>
            <span class="section-title">Отраслевые решения</span>
            <div data-arr="industry" class="inputs-wrapper">
              <div>
                <input v-model="industry.food" name="industry_food" type="text" placeholder="Пищевая промышленность">
              </div>
              <div>
                <input v-model="industry.diy" name="industry_diy" type="text" placeholder="DIY LOGISTIC">
              </div>
              <div>
                <input v-model="industry.fmcg" name="industry_fmcg" type="text" placeholder="FMCG логистика">
              </div>
              <div>
                <input v-model="industry.automotive" name="industry_automotive" type="text" placeholder="Автомобильная промышленность">
              </div>
              <div>
                <input v-model="industry.chemical" name="industry_chemical" type="text" placeholder="Химическая промышленность">
              </div>
              <div>
                <input v-model="industry.homeappliances" name="industry_homeappliances" type="text" placeholder="Индустрия бытовой техники">
              </div>
            </div>
            <span class="section-title">Комплексные решения</span>
            <div data-arr="complex" class="inputs-wrapper">
              <div>
                <input v-model="complex.contract" name="complex_contract" type="text" placeholder="Контрактная логистика">
              </div>
              <div>
                <input v-model="complex.high" name="complex_high" type="text" placeholder="Высокоточная логистика">
              </div>
              <div>
                <input v-model="complex.chain" name="complex_chain" type="text" placeholder="Решения по цепочке поставки">
              </div>
              <div>
                <input v-model="complex.warehouse" name="complex_warehouse" type="text" placeholder="Складская логистика">
              </div>
            </div>
            <span class="section-title">Сервисы</span>
            <div data-arr="services" class="inputs-wrapper">
              <div>
                <input v-model="services.transport" name="services_transport" type="text" placeholder="Транспортные грузоперевозки">
              </div>
              <div>
                <input v-model="services.rail" name="services_rail" type="text" placeholder="Железнодорожные грузоперевозки">
              </div>
              <div>
                <input v-model="services.air" name="services_air" type="text" placeholder="Воздушные грузоперевозки">
              </div>
              <div>
                <input v-model="services.sea" name="services_sea" type="text" placeholder="Морские грузоперевозки">
              </div>
              <div>
                <input v-model="services.add" name="services_add" type="text" placeholder="Дополниельные услуги">
              </div>
            </div>
            <span class="section-title">Тексты шапки/подвала</span>
            <div data-arr="texts" class="inputs-wrapper">
              <div>
                <input v-model="texts.contacts" name="texts_contacts" type="text" placeholder="Контакты">
              </div>
              <div>
                <input v-model="texts.social" name="texts_social" type="text" placeholder="Мы в соц. сетях:">
              </div>
              <div>
                <input v-model="texts.information" name="texts_information" type="text" placeholder="Информация">
              </div>
              <div>
                <input v-model="texts.telephone" name="texts_telephone" type="text" placeholder="Телефон: ">
              </div>
              <div>
                <input v-model="texts.copyright" name="texts_copyright" type="text" placeholder="Копирайт">
              </div>
              <span class="section-title">Форма подписки на новости</span>
              <div>
                <input v-model="texts.subscribe" name="texts_subscribe" type="text" placeholder="Зпголовок">
              </div>
              <div>
                <input v-model="texts.placeholder" name="texts_placeholder" type="text" placeholder="Плейсхолдер Email">
              </div>
              <div>
                <input v-model="texts.submit" name="texts_submit" type="text" placeholder="Текст кнопки отправить">
              </div>
              <div>
                <input v-model="texts.subscribesuccess" name="texts_subscribesuccess" type="text" placeholder="Сообщение при успешной подписке">
              </div>
              <div>
                <input v-model="texts.subscribeerror" name="texts_subscribeerror" type="text" placeholder="Текст ошибки при неверном email">
              </div>
            </div>
            <span class="section-title">Контакты</span>
            <div data-arr="contacts" class="inputs-wrapper">
              <div>
                <input v-model="contacts.email" name="contacts_email" type="text" placeholder="Email">
              </div>
              <div>
                <input v-model="contacts.telephone" name="contacts_telephone" type="text" placeholder="Телефон">
              </div>
              <div>
                <input v-model="contacts.address" name="contacts_address" type="text" placeholder="Адрес">
              </div>
            </div>
            <span class="section-title">Карта <br/>в формате Город|Страна|Координаты<br/>каждый город с новой строки</span>
            <div data-arr="contacts" class="inputs-wrapper">
              <div>
                <textarea v-model="contacts.mapdata" name="contacts_mapdata" placeholder="Город|Страна|Координаты" rows="10"></textarea>
              </div>
            </div>
            <span class="section-title">Ссылки соц. сетей</span>
            <div data-arr="socials" class="inputs-wrapper">
              <div>
                <input v-model="socials.fb" name="socials_fb" type="text" placeholder="FaceBook">
              </div>
              <div>
                <input v-model="socials.twitter" name="socials_twitter" type="text" placeholder="Twitter">
              </div>
              <div>
                <input v-model="socials.linkedin" name="socials_linkedin" type="text" placeholder="LinkedIn">
              </div>
              <div>
                <input v-model="socials.instagram" name="socials_instagram" type="text" placeholder="Instagram">
              </div>
              <div>
                <input v-model="socials.pinterest" name="socials_pinterest" type="text" placeholder="Pinterest">
              </div>
            </div>
            <div v-show="success" v-bind:class="{'show' : success}" class="alert alert-success left fade" role="alert">Save changes have been made</div>
            <div class="send-btns">
              <div class="submit-btn">
                <input type="submit" value="Save">
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </main>
</template>

<script>

import {HTTP} from '../http-common'

export default {
  name: 'Admin',

  data() {
    return {
      links: {},
      texts: {},
      socials: {},
      services: {},
      industry: {},
      complex: {},
      contacts: {},
      hfInfo: {},
      success: false,
      email: '',
      password: '',
      errors: []
    }
  },

  created() {
    this.getHFInfo()
  },

  watch:{
    $route (to, from) {
      this.getHFInfo()
    }
  },

  methods: {
    LogIn(event) {
      event.preventDefault()

      HTTP.post('/Users/login', {
        email: this.email,
        password: this.password
      }).then(response => {
        if (response.data && response.data.id) {
            localStorage.setItem('accessToken', response.data.id)
            this.$root.accessToken = response.data.id

            location.replace('/')
        }
      }).catch(e => {
        this.errors.push(e)
      })
    },

    isLogged() {
      return this.$root.isAdmin()
    },

    getHFInfo() {
      HTTP.get('settings?filter=' + encodeURIComponent(JSON.stringify({
        where: {
          and: [
            {key: 'header-footer'},
            {language_id: this.$root.language_id}
          ]
        }
      }))).then(response => {
        if (response.data.length) {
          this.hfInfo.data = response.data[0].value.length ? JSON.parse(response.data[0].value) : {}
          this.hfInfo.id = response.data[0].id
          this.hfInfo.key = response.data[0].key
          this.hfInfo.language_id = response.data[0].language_id

          for (let group in this.hfInfo.data) {
            this[group] = this.hfInfo.data[group]
          }
        }
      }).catch(e => {
        this.errors.push(e)
      })
    },

    submitInfo(event) {
      event.preventDefault()

      HTTP.patch('settings/' + this.hfInfo.id + '?access_token=' + this.$root.accessToken, {
        language_id: this.hfInfo.language_id,
        key: this.hfInfo.key,
        value: JSON.stringify({
          links: this.links,
          texts: this.texts,
          socials: this.socials,
          services: this.services,
          industry: this.industry,
          complex: this.complex,
          contacts: this.contacts
        })
      }).then(response => {
        if (response.status && response.status == 200) {
          this.success = true

          this.errors = []

          setTimeout(() => {
            this.success = false
            location.reload()
          }, 1000)
        }
      }).catch(e => {
        this.errors = []
        this.errors.push(e.response.data.error)
      })
    }
  }

}

</script>

<style scoped>
  .admin-login-form form {
    float: none;
    margin: auto;
  }
</style>
